export const GET_EDITED_PHOTO_ORDERS_SUCCESS = 'GET_EDITED_PHOTO_ORDERS_SUCCESS';
export const GET_UNEDITED_PHOTO_ORDERS_SUCCESS = 'GET_UNEDITED_PHOTO_ORDERS_SUCCESS';
export const GET_UNEDITED_FUTURE_PHOTO_ORDERS_SUCCESS = 'GET_UNEDITED_FUTURE_PHOTO_ORDERS_SUCCESS';
export const SET_ORDER_AS_ASSIGNED_SUCCESS = 'SET_ORDER_AS_ASSIGNED_SUCCESS';
export const SET_ORDER_AS_UNASSIGNED_SUCCESS = 'SET_ORDER_AS_UNASSIGNED_SUCCESS';
